export const ADMIN_NOTIFICATION_TYPE_UP_AND_COMING = "UP_AND_COMING" as const;

export type AdminNotificationType =
  | typeof ADMIN_NOTIFICATION_TYPE_UP_AND_COMING
  | string;

export type UpAndComingNotificationPayload = {
  universeId: number;
  name?: string | null;
  visitsChangeRateLast7d?: number;
  iconUrl?: string | null;
  displayGenre?: string | null;
};
